// What each list is, and what its Amount column means.
export const ITEM_KINDS = {
  conversions_unmirrored: {
    title: "Conversions with no house-merchant counterpart",
    note: "Amount is what the conversion moved on the consumer side in this currency (negative = the consumer paid it, positive = the consumer received it). The house merchant did none of it.",
  },
  pre_mirror_conversions: {
    title: "Conversions made before the house-merchant mirror (before 4 Oct)",
    note: "These happened before the mirror existed, so the house merchant never made the other side. Amount is what the conversion moved on the consumer side in this currency.",
  },
  conversion_drift_short: {
    title: "Mirrored conversions where the house merchant was credited less",
    note: "Amount is how much less the house merchant was credited than the consumer received (the rate moved between the two steps).",
  },
  septly_credited: {
    title: "Septly deposits credited to consumers, missing on the house merchant",
    note: "Amount is what the consumer was credited (deposit minus the gateway fee). The house merchant has no matching row.",
  },
  septly_held: {
    title: "Held Septly deposits with no house-merchant manual-review row",
    note: "The consumer is not credited yet and the house merchant has no row, so they are invisible on the merchant page.",
  },
  one_sided_payouts: {
    title: "Withdrawals debited from the consumer but never sent",
    note: "Amount is what was debited from the consumer. Nothing exists on the business side. See Orphaned Payouts to resolve them.",
  },
  declined_after_dispatch: {
    title: "Payouts declined and refunded after the provider payout existed",
    note: "The consumer was refunded but the house merchant is still debited. Check each at the provider before correcting.",
  },
  payout_fee_difference: {
    title: "Payouts where the consumer and house merchant paid different fees",
    note: "Amount is consumer fees minus house-merchant fees (positive = the consumer paid more).",
  },
  manual_review_held: {
    title: "Deposits held for manual review",
    note: "Amount is what the sender paid. Nobody's balance holds it yet. For a card deposit through Septly the house merchant is credited the moment the payment succeeds, while the customer is only credited when the review is approved.",
  },
  campaign_rewards: {
    title: "Campaign rewards funded by Novacrust",
    note: "Credited to the consumer from Novacrust's own pocket, with no house-merchant movement. Expected, not an error.",
  },
};
